
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl=null) {
        const url = `${API_URL}/media?page=${pageUrl}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/media/${id}`, { headers: authHeader() });
    },
    createData(data) {
        const headers = authHeader();
        // Si es FormData, no establecer Content-Type para que el navegador lo establezca automáticamente
        if (data instanceof FormData) {
            return axios.post(`${API_URL}/media`, data, { 
                headers: {
                    ...headers,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        return axios.post(`${API_URL}/media`, data, { headers });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/media/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/media/${id}`, { headers: authHeader() });
    },
   
};